<input type="number" min="0" [formControl]="control" (change)="inputValueChanged($event)" />
